import React from "react"
import Container from "@ecom/ui/components/Container"
import Typography from "@material-ui/core/Typography"
import Breadcrumbs from "@material-ui/core/Breadcrumbs"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import { AppLinkMui } from "@ecom/ui/components/AppLink"
import * as styles from "./breadcrumbs.module.scss"

export type Breadcrumb = { url?: string; shortTitle?: string }

type BreadcrumbsProps = {
  linkList?: Breadcrumb[]
  orderNum?: string
  variantStyles?: "applyCardsCredit"
}

export const BreadcrumbsComponent = ({
  linkList = [],
  orderNum,
  variantStyles,
}: BreadcrumbsProps) => (
  <div data-exclude={orderNum} className={variantStyles && styles[variantStyles]}>
    <Container className={styles.container}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        className={styles.breadcrumbs}
      >
        {linkList.map(
          ({ url, shortTitle }, index) =>
            shortTitle &&
            (index + 1 < linkList.length ? (
              <AppLinkMui color="inherit" href={url} target="_blank" key={url}>
                {shortTitle}
              </AppLinkMui>
            ) : (
              <Typography key={url} color="textPrimary">
                {shortTitle}
              </Typography>
            ))
        )}
      </Breadcrumbs>
    </Container>
  </div>
)
